/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PrepaidBookingValidationParamDTO = {
    NO_ISSUES: 'NO_ISSUES',
    ONLY_ISSUES: 'ONLY_ISSUES',
    ALL: 'ALL'
} as const;
export type PrepaidBookingValidationParamDTO = typeof PrepaidBookingValidationParamDTO[keyof typeof PrepaidBookingValidationParamDTO];

